import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import Dialog, {DIALOG_ACTIONS} from './dialog';
import Vue from 'vue';

function factory(options) {
    var el = document.createElement('div');
    var DialogConstructor = Vue.extend(Dialog);
    var filteredOptions = Object.entries(options)
        .filter(function(_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                value = _ref2[1];

            return value !== undefined;
        })
        .reduce(function(val, _ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
                key = _ref4[0],
                value = _ref4[1];

            return Object.assign(Object.assign({}, val), _defineProperty({}, key, value));
        }, {});
    var dialogInstance = Object.assign(
        new DialogConstructor({
            el: el
        }),
        filteredOptions
    );
    dialogInstance.$on('input', function(value) {
        dialogInstance.show = value;
    });
    dialogInstance.$on('closed', function() {
        var _a;

        dialogInstance.container().removeChild(dialogInstance.$el);
        dialogInstance.$destroy();
        (_a = dialogInstance.$refs.popup) === null || _a === void 0 ? void 0 : _a.$destroy();
    });
    dialogInstance.container().appendChild(dialogInstance.$mount().$el);
    return dialogInstance;
}

var DialogFunction = function DialogFunction(options) {
    return new Promise(function(resolve) {
        var component = factory(
            Object.assign(Object.assign({}, options), {
                show: true
            })
        );
        var lastAction;
        var nonAbortResult = new Promise(function(res) {
            if (options.beforeClose) {
                component.$on('before-close-resolved', function(abort) {
                    return !abort ? res() : null;
                });
            } else {
                res();
            }
        });

        var resolvedWhenNonAbort = function resolvedWhenNonAbort(action) {
            lastAction = action;
            return nonAbortResult.then(function() {
                return resolve({
                    action: lastAction
                });
            });
        };

        component.$on('cancel', function() {
            return resolvedWhenNonAbort(DIALOG_ACTIONS.CANCEL);
        });
        component.$on('confirm', function() {
            return resolvedWhenNonAbort(DIALOG_ACTIONS.CONFIRM);
        });
        component.$on('close', function() {
            return resolvedWhenNonAbort(DIALOG_ACTIONS.CLOSE);
        });
    });
};

DialogFunction.install = function(Vue) {
    Dialog.install(Vue);
    Vue.prototype.$dialog = DialogFunction;
};

DialogFunction.confirm = function(options) {
    return DialogFunction({
        title: options.title,
        message: options.message,
        confirmButtonColor: options.confirmButtonColor,
        confirmButtonText: options.confirmButtonText,
        cancelButtonColor: options.cancelButtonColor,
        cancelButtonText: options.cancelButtonText,
        beforeClose: options.beforeClose,
        container: options.container,
        cancelButton: true
    }).then(function(_ref5) {
        var action = _ref5.action;

        if (action === DIALOG_ACTIONS.CONFIRM) {
            return Promise.resolve();
        } else if (options.throwWhenCancel) {
            return Promise.reject(new Error());
        }
    });
};

DialogFunction.Component = Dialog;

DialogFunction.alert = function(options) {
    return DialogFunction({
        title: options.title,
        message: options.message,
        confirmButtonColor: options.confirmButtonColor,
        confirmButtonText: options.confirmButtonText,
        cancelButtonColor: options.cancelButtonColor,
        cancelButtonText: options.cancelButtonText,
        beforeClose: options.beforeClose,
        container: options.container
    }).then(function() {
        return Promise.resolve();
    });
};

export default DialogFunction;
